var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7618 16.1445L26.5714 16.1445L26.5714 20.335",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7372 18.116C21.3447 18.6255 20.1494 19.5912 19.3314 20.8675C18.5133 22.1439 18.1168 23.6618 18.2017 25.1925C18.2865 26.7232 18.848 28.1838 19.8017 29.3542C20.7553 30.5247 22.0494 31.3415 23.4889 31.6817C24.9285 32.022 26.4355 31.8671 27.7829 31.2405C29.1303 30.6138 30.2452 29.5494 30.9594 28.2076C31.6737 26.8657 31.9487 25.3191 31.743 23.8008C31.5373 22.2825 30.8621 20.8748 29.819 19.7897L26.634 16.2695",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9998,
    cy: 25.048,
    r: 1.57143,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotation);
export default __webpack_public_path__ + "static/media/ic_rotation.487dcfbbd1e8334ed029fa0f49d79f3f.svg";
export { ForwardRef as ReactComponent };